var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],ref:"panel",staticClass:"panel",style:({ position: 'fixed', left: (_vm.xPos + "px"), top: (_vm.yPos + "px")})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }